module.exports = __webpack_public_path__ + "img/tuijianchapin.cfa60365.png";